import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockSettings } from 'venn-state';
import { Block } from '../../components/core';
import { useHoldings } from '../../../studio-blocks/logic/useHoldings';

export const HoldingsAssetClassDisclaimer = ({ id }: { id: string }) => {
  const settings = useRecoilValue(blockSettings(id));
  const { data } = useHoldings(id);
  const hasNegativeAssets = (data?.hasNegativeAssets ?? []).includes(true);

  if (settings.customBlockType !== 'ASSET_EXPOSURE' || !hasNegativeAssets) {
    return null;
  }

  return <Block.Footer id={id}>Asset Class breakdown is based on a portfolio's total long allocations.</Block.Footer>;
};
